/** @jsx jsx */
import { jsx } from '@emotion/react';
import styled from '@emotion/styled';
import { ChevronLeft, ChevronRight } from 'react-feather';
import { onSm } from '../../styles/responsive';
import { Link } from '../Link/Link';
import { colors } from '../../theme';

const Arrow = styled(({ className, arrow }) => <div className={className}>{arrow.render({ color: '' })}</div>)`
  display: block;
  margin: 0;
  flex: 0 0 auto;
  font-size: 16pt;
  transition: color 200ms ease 0s;
  padding: 16px;

  ${onSm} {
    padding: 6px;
  }
  svg {
    stroke: ${(props) => props.theme.previousNext.font};
  }
`;

const Title = styled.div`
  display: block;
  margin: 0;
  padding: 0;
  transition: color 200ms ease 0s;

  span {
    font-size: 16px;
    line-height: 1.5;
    font-weight: 500;
  }
`;

const Label = styled.div`
  display: block;
  margin: 0;
  padding: 0;
  color: ${(props) => props.theme.previousNext.fontLabel};

  span {
    font-size: 12px;
    line-height: 1.625;
    font-weight: 400;
  }
`;

const ContentWrapper = styled(({ className, label, title }) => {
  return (
    <div className={className}>
      <Label>
        <span>{label}</span>
      </Label>
      <Title>
        <span>{title}</span>
      </Title>
    </div>
  );
})`
  display: block;
  margin: 0;
  flex: 1 1 0%;
  padding: 16px;
  ${onSm} {
    padding: 6px;
  }
`;

const LeftButton = ({ url, title, label }) => {
  return (
    <Button url={url}>
      <Arrow arrow={ChevronLeft} />
      <ContentWrapper title={title} label={label} css={{ textAlign: 'right' }} />
    </Button>
  );
};

const RightButton = ({ url, title, label }) => {
  return (
    <Button url={url}>
      <ContentWrapper title={title} label={label} />
      <Arrow arrow={ChevronRight} />
    </Button>
  );
};

const Button = styled(({ className, url, children }) => {
  return (
    <Link to={url || '#'} className={className}>
      {children}
    </Link>
  );
})`
  cursor: pointer;
  -moz-box-align: center;
  -moz-box-direction: normal;
  -moz-box-orient: horizontal;
  margin: 0;
  padding: 0;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  place-self: stretch;
  color: ${(props) => props.theme.previousNext.font};
  background-color: ${colors.background};
  border-radius: 6px;
  border: 1.5px solid ${(props) => props.theme.previousNext.border};
  box-shadow: ${(props) => props.theme.previousNext.shadow} 0 3px 8px;
  text-decoration: none;
  visibility: ${(props) => (props.url ? 'visible' : 'hidden')};
  opacity: ${(props) => (props.url ? 1 : 0)};

  &:hover {
    color: ${(props) => props.theme.previousNext.hover};
    text-decoration: none;
    border: 1.5px solid ${(props) => props.theme.previousNext.hover};
    svg * {
      stroke: ${(props) => props.theme.previousNext.hover};
    }
  }
`;

// const setArrowNavigation = (previous, next) => {
//   useEffect(() => {
//     document.onkeydown = (e) => {
//       e = e || window.event;
//       if (e.keyCode == '37' && previous.url) {
//         // left arrow
//         navigate(previous.url);
//       } else if (e.keyCode == '39' && next.url) {
//         // right arrow
//         navigate(next.url);
//       }
//     };
//   }, [previous, next]);
// };

type ButtonProps = { url?: string; title?: string; label?: string };

export const PreviousNext = ({ left = {}, right = {} }: { left?: ButtonProps; right?: ButtonProps }) => {
  return (
    <div
      css={{
        marginTop: '40px',
        padding: '0',
        width: 'auto',
        display: 'grid',
        gridTemplateRows: 'auto',
        columnGap: '24px',
        gridTemplateColumns: 'calc(50% - 12px) calc(50% - 12px)'
      }}
    >
      <LeftButton url={left.url} title={left.title} label="Previous" />
      <RightButton url={right.url} title={right.title} label="Next" />
    </div>
  );
};

// export default PreviousNext;
